import React, { useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getFirestore, doc, updateDoc } from 'firebase/firestore';
import { app } from '../firebase';
import { fetchDoc, useUser } from '../contexts/UserContext';

/**
 * Composant qui vérifie si l'utilisateur a accès à la copropriété spécifiée,
 * met à jour la copropriété active si nécessaire, puis redirige vers le dashboard
 * avec la section appropriée
 */
function CoownershipRedirect({ menu = "residence" }) {
  const { coownershipId } = useParams();
  const navigate = useNavigate();
  const user = useUser();
  const db = getFirestore(app);
  const deactivatedAlertShown = useRef(false);

  useEffect(() => {
    const checkAndRedirect = async () => {
      // Si on n'a pas d'ID de copropriété ou pas d'utilisateur, rediriger vers le dashboard
      if (!coownershipId || !user.user) {
        navigate('/dashboard');
        return;
      }

      try {
        // Vérifier si l'utilisateur a accès à cette copropriété
        const userCoownerships = user.user.userData.coownershipId || [];
        
        // Chercher si la copropriété existe dans la liste des copropriétés de l'utilisateur
        const coownershipExists = userCoownerships.some(item => {
          return item.coownershipReference?.path?.includes(coownershipId);
        });

        if (!coownershipExists) {
          console.log("L'utilisateur n'a pas accès à cette copropriété");
          navigate('/dashboard');
          return;
        }

        const docRefCoownership = doc(db, "coownership/"+coownershipId);
        const coownershipData = await fetchDoc(docRefCoownership);

        if (!coownershipData || coownershipData.status !== "activated") {
          if (!deactivatedAlertShown.current) {
            deactivatedAlertShown.current = true;
            alert("Cette copropriété n'est plus active. Choisissez-en une autre ou ajoutez-en une nouvelle.");
          }
          navigate('/coownership');
          return;
        }
        
        // Si la copropriété active est différente de celle demandée, mettre à jour
        const currentCoownershipPath = user.user.userData.lastCoownershipLoaded?.path;
        if (!currentCoownershipPath || !currentCoownershipPath.includes(coownershipId)) {
          //on envoie les données sur firestore 
          const userDoc = doc(db, "users/"+user.user.user.uid);
      
          await updateDoc(userDoc, {
            lastCoownershipLoaded: docRefCoownership,
          });
      
          let userData = user.user.userData; 
      
          userData.lastCoownershipLoaded = docRefCoownership;
          userData.isLastCoownershipDeactivated = false;
      
          if(coownershipData.name){              
            userData.nameCoownershipLoaded = coownershipData.name; 
            userData.codeOwner = coownershipData.codeOwner;
            userData.rentalManagerCreateContent = coownershipData.rentalManagerCreateContent ?? false;
          }
      
          //on update le contexte de l'utilisateur 
          user.setUser({user: user.user.user, userData: userData});
          // Rediriger vers le dashboard avec le menu spécifié

          navigate('/dashboard', { state: { initialMenu: menu } });
        } else {
          // Si c'est déjà la copropriété active, juste rediriger vers le menu
          navigate('/dashboard', { state: { initialMenu: menu } });
        }
      } catch (error) {
        console.error("Erreur lors de la vérification de la copropriété:", error);
        //navigate('/dashboard');
      }
    };

    checkAndRedirect();
  }, [coownershipId, user, navigate, menu, db]);

  // Afficher un message de chargement pendant la vérification et la redirection
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary mb-4"></div>
      <p className="text-lg text-gray-700">Vérification de l'accès à la copropriété...</p>
    </div>
  );
}

export default CoownershipRedirect;
